<template>
	<div class="con-1334 box-white mt-30px">
		<div v-if="!noStatements" class="section__wrapper con-1060">
			<h3 class="section__title">Biztosítói nyilatkozatok</h3>
			<div class="section">
				<div class="section__checkbox">
					<CalcElem
						name="MARKETING_NY"
						:options="{
							label: 'A <a href=\'/pdf/alfa_marketing.pdf\' target=\'_blank\'>marketing célú adatkezelési tájékoztató</a> alapján önként hozzájárulok, hogy az Adatkezelő – a tájékoztatóban foglaltak szerint – közvetlen üzletszerzési célú tartalmakkal megkereshesse és ennek érdekében a személyes adataimat nyilatkozatom visszavonásáig kezelje.',
							type: 'checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							className: 'mw-500px',
							group: 'statements',
							insurer: 'ALF',
							prop: 'MARKETING_NY',
						}"
						type="contracting"
						class="checkbox-center"
					/>
				</div>
			</div>
		</div>
        <div class="section__wrapper con-1060" v-if="euroriskMarketing">
            <div class="section__text"><b>Eurorisk Marketing nyilatkozat:</b></div>
            <CalcElem
                name="euroriskMarketing"
                :options="{
							label: 'Igen',
							type: 'yes-no-checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							inputClass: 'w-100 mobile-width-full d-flex items-center justify-center',
							className: 'mw-500px',
							prop: 'euroriskMarketing',
						}"
                type="contracting"
            />
        </div>
		<div class="section__wrapper con-1200" v-if="!noContract">
			<h3 class="section__title">Alkuszi megbízás</h3>
			<div class="section">
				<div class="section__text text-center" v-if="!noStatements">
					Kérjük, töltse le az Alkuszi megbízás+Igényfelmérő+Biztosítás közvetítői elemzés, a Biztosítási
					feltételek, valamint az Eurorisk ÁSZF nevű dokumentumokat, majd szíveskedjen áttanulmányozni és
					megismerni a szerződés megkötésére vonatkozó feltételeket és nyilatkozatokat. Biztosítási
					szerződésének megkötésére ezt követően van lehetőség.
				</div>
                <div class="section__text text-center" v-if="noStatements">
                    Kérjük, töltse le az Alkuszi megbízás+Igényfelmérő+Biztosítás közvetítői elemzés és a Biztosítási
                    feltételek, nevű dokumentumokat, majd szíveskedjen áttanulmányozni és
                    megismerni a szerződés megkötésére vonatkozó feltételeket és nyilatkozatokat. Biztosítási
                    szerződésének megkötésére ezt követően van lehetőség.
                </div>
				<div class="section__files">
					<FileButton
						v-for="(file, index) in files"
						:key="index"
						:name="file.title"
						:link="computedLinks[index]"
						:type="file.type"
						@clicked="file.clicked = true"
					/>
				</div>
				<div class="section__checkbox section__checkbox--center" v-if="!downloadNotRequired">
					<CalcElem
						name="allFilesAccepted"
						:options="{
							label: 'Az ajánlat tartalmát ellenőriztem, a mellékelt tájékoztatókat és feltételeket megértettem, ez alapján a kiválasztott biztosítási szerződés megkötésére alkuszi megbízást adok az Eurorisk Kft-nek.',
							type: 'checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							className: 'mw-500px',
							prop: 'allFilesAccepted',
						}"
						type="contracting"
						class="checkbox-center"
						:disabled="isDisabled"
						@click="handleAllFilesAcceptedClick()"
					/>
					<span class="error_message error_message--broke" v-if="errors.allFilesAccepted">
						{{ errors.allFilesAccepted }}
					</span>
				</div>
                <div class="section__checkbox section__checkbox--center" v-if="privacyRequired">
                    <CalcElem
                        name="privacyAccept"
                        :options="{
                            label: 'Az Eurorisk Kft. <a href=\'/adatvedelem\' target=\'_blank\'>adatkezelési tájékoztatóját</a> elolvastam és megértettem.',
							type: 'checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							className: 'mw-500px',
							prop: 'privacyAccept',
						}"
                        type="contracting"
                        class="checkbox-center"
                    />
                    <span class="error_message error_message--broke" v-if="errors.privacyAccept">
						{{ errors.privacyAccept }}
					</span>
                </div>
                <div class="section__checkbox section__checkbox--center" v-if="!computedIsNewContract">
                    <CalcElem
                        name="terminationAuthorizationAccepted"
                        :options="{
							label: 'A jelenlegi lakásbiztosítási szerződésem felmondására megbízást adok az Eurorisk Kft.-nek.',
							type: 'checkbox',
							wrapperClass: 'col-w100-chbox chbox_style-wrapper',
							className: 'mw-500px',
							prop: 'terminationAuthorizationAccepted',
						}"
                        type="contracting"
                        class="checkbox-center"
                        @click="handleAllFilesAcceptedClick()"
                    />
                    <span class="error_message error_message--broke" v-if="errors.terminationAuthorizationAccepted">
						{{ errors.terminationAuthorizationAccepted }}
					</span>
                </div>
			</div>
		</div>
	</div>
</template>

<script>
import statementData from '@/mixins/statementData';

export default {
    created() {
        // if(this.allChecked){
        //     this.checkboxes.forEach(statement => {
        //         const parts = statement.split('.');
        //         this.setCheckboxData({ group:'statements', insurer:parts[0], prop:parts[1], value:true });
        //     });
        // }

        if(this.downloadNotRequired) {
            this.setCheckboxData({ prop:'allFilesAccepted', value:true });
        }
    },
    props: {
        noContract: {type: Boolean, default: false},
        downloadNotRequired: {type: Boolean, default: false},
        allChecked: {type: Boolean, default: false},
        noStatements: {type: Boolean, default: false},
        privacyRequired: {type: Boolean, default: false},
        euroriskMarketing: {type: Boolean, default: false},
    },
	mixins: [statementData],
	data() {
		return {
			aszf_link: 'alfa/aszf',
			checkboxes: ['ALF.MARKETING_NY.canFalse'],
		};
	},
};
</script>

<style lang="scss" scoped>
.section__title {
	text-align: center;
}

@media only screen and (max-width: 1100px) {
	.con-1334 {
		padding: 15px;
	}

	.checkbox-center {
		display: flex;
		justify-content: center;
	}
}

.section {
	&__text {
		font-family: Arial;
		font-style: normal;
		font-weight: normal;
		font-size: 16px;
		line-height: 24px;
		color: #1f2835;
	}

	&__checkbox {
		margin: 15px 0;

		&--center {
			max-width: 700px;
			margin: 45px auto 60px auto;
		}
	}

	&__files {
		display: flex;
		justify-content: center;
		margin-top: 30px;

		@media only screen and (max-width: 1100px) {
			flex-direction: column;
			align-items: center;

			.file-button {
				margin: 10px;
			}
		}
	}
}
</style>
